import React, { useState } from 'react';
import styles from './MediaUploader.module.scss';
//props
import { Mediafile } from '../interfaces/Media';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';
//utils
import { toast } from 'react-toastify';
//icons
import SVG from 'react-inlinesvg';
import Close from '../../../assets/icons/close.svg';
import Play from '../../../assets/icons/play.svg';
import { MdAdd } from 'react-icons/md';

interface MediaUploaderProps {
  onSelect: (files: Mediafile[]) => void;
  value: Mediafile[];
}

export const MediaUploader: React.FC<MediaUploaderProps> = ({
  onSelect,
  value,
}) => {
  const { t } = useTranslation();
  const [mediaFiles, setMediaFiles] = useState<Mediafile[]>(value);

  const getPreview = (file: File) => {
    const fileType = file.type;
    if (fileType.includes('video')) {
      return Play;
    } else if (fileType.includes('audio')) {
      return Play;
    } else {
      return URL.createObjectURL(file);
    }
  };
  const onDeleteMedia = (index: number) => {
    const filteredFiles = mediaFiles.filter((element, i) => i !== index);
    setMediaFiles(filteredFiles);

    onSelect(filteredFiles);
  };

  // On file select
  const onMediaUpload = (e: any) => {
    const selectedFiles: File[] = Array.from(e.target.files);
    const validFiles = selectedFiles.map((file: File) => ({
      file: file,
      type: file.type,
      preview: getPreview(file),
    }));

    if (validFiles.length > 4 || [...mediaFiles, ...validFiles].length > 4) {
      return toast.error(tr(t, 'img-number_error'));
    }

    // Update the state
    e.target.value = null;
    const newState = [...mediaFiles, ...validFiles];

    setMediaFiles(newState);

    onSelect(newState);
  };

  const renderLoadedMedia = () => {
    return mediaFiles.map((mediaFile: Mediafile, index: number) => (
      <div
        className={styles.mediaContainer}
        key={`${mediaFile.file.name}-${mediaFile.file.size}-${index}`}
      >
        <div className={styles.previewWrapper}>
          <div
            className={styles.imgPreview}
            style={{
              backgroundImage: `url('${getPreview(mediaFile.file)}')`,
            }}
          ></div>
          <p>{mediaFile.file.name}</p>
          <div
            className={styles.handleClickContainer}
            onClick={() => {
              onDeleteMedia(index);
            }}
          >
            <SVG src={Close} className={styles.close} />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className={styles.MediaUploader}>
      <div className={styles.uploadbtn}>
        <button type={'button'} disabled={mediaFiles.length >= 4}>
          <MdAdd size={10} className={styles.addBtn} />
          {tr(t, 'img-upload')}
          <label>{tr(t, 'max-image_info')}</label>
        </button>

        <input
          type="file"
          multiple
          onChange={(file) => onMediaUpload(file)}
          id={styles.uploadBtn}
        />
      </div>
      <div className={styles.loadedMediaWrapper}>{renderLoadedMedia()}</div>
    </div>
  );
};
